import { z } from 'zod';

const ModelSchema = z.object({
  modelId: z.string().uuid('Model name is required'),
  sizeId: z.string().uuid('Size is required'),
  position: z.array(z.string()).nonempty('Position is required'),
  quantity: z
    .union([z.string(), z.number()])
    .refine(
      (val) => {
        const num = typeof val === 'string' ? Number(val) : val;
        return !isNaN(num);
      },
      { message: 'Quantity must be a number' }
    )
    .transform((val) => (typeof val === 'string' ? Number(val) : val))
    .refine((val) => val >= 0 && val <= 1000, {
      message: 'Quantity must be 0–1000',
    }),
});

const PrinterSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  printerId: z.string().min(1, 'Printer is required'),
  type: z.string().min(1, 'Type is required'),
});

const StyleSchema = z.object({
  styleId: z.string().uuid('Style is required'),
});

const OverlaySchema = z.object({
  overlayId: z.string().uuid('Overlay is required'),
});

const MaskSchema = z.object({
  maskId: z.string().uuid('Mask is required'),
  overlays: z.array(OverlaySchema).optional(),
});

export const EventFormSchema = z.object({
  name: z
    .string()
    .min(3, 'Event name must be at least 3 characters long')
    .regex(/^[a-zA-Z0-9 ]+$/, {
      message: 'Only letters and numbers are allowed',
    })
    .max(100, 'Event name cannot exceed 100 characters'),
  startDate: z.string().refine((val) => !isNaN(Date.parse(val)), {
    message: 'Start date is required',
  }),
  types: z.array(z.string()).min(1, 'At least one type is required'),
  idleStateVideoPublicUrl: z.string().optional(),
  publicUrl: z.string().min(1, 'Video preview is required'),
  aiModel: z.string().min(1, 'AI model is required'),
  printers: z.array(PrinterSchema).min(1, 'At least one printer is required'),
  models: z.array(ModelSchema).min(1, 'At least one model is required'),
  styles: z.array(StyleSchema).min(1, 'At least one style is required'),
  masks: z.array(MaskSchema).min(1, 'At least one mask is required'),
});
